import api from "../..";

export const deleteCategory = async ({ id }: { id: number }): Promise<boolean> => {

  return await api.delete(`/category/${id}/`)
  .then(() => true)
  .catch(() => false);
};